module.exports = __webpack_public_path__ + "resources/img/img-security-securegate-1.dac2a0e81a4ca0e1e6662e9741ff09ef.png";